import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { apiUrl } from 'src/app/global/global';
import { AdminService } from 'src/app/services/admin.service';
import { UserDetailsService } from 'src/app/services/user/user-details.service';
import swal from "sweetalert2";

@Injectable({
  providedIn: 'root'
})
export class DeleteAccountService {

  constructor(private api: AdminService, private router: Router) { }

  deleteAccountConfirmation(request?: any) {
    let text = "<p>Are you sure You want to Delete this Account?</p>";
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.value) {
        this.api.postData(apiUrl._deleteAccount, request).subscribe(res => {
          window.localStorage.clear();
          localStorage.clear()
          localStorage.removeItem("accessToken");
          localStorage.removeItem("deviceToken");
          localStorage.removeItem("UserData");
          localStorage.removeItem("isPasswordSet");
          localStorage.removeItem("login_type");
          localStorage.removeItem("userType");
          localStorage.removeItem("userDetail");
          localStorage.removeItem("s3Folders");
          this.router.navigate(["/home"]);
        })
      }
    });
  }
}
